import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { v4 as uuidV4 } from 'uuid';
import moment from 'moment';
import React, { useMemo } from 'react';
import classnames from 'classnames';
import { kebabCase } from 'lodash';
import AddFromOptionsButton from './addFromOptionsButton';
import { convertToAbsolutePath } from '../utils';
import { enabledSelector, valueSelector, labelSelector, newPathSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import logValueOnChange from '../commonActions/logValueOnChange';
const AddButton = _ref => {
  let enabled = _ref.enabled,
    contentPath = _ref.contentPath,
    _ref$groupedOptions = _ref.groupedOptions,
    groupedOptions = _ref$groupedOptions === void 0 ? [] : _ref$groupedOptions,
    _ref$initialContent = _ref.initialContent,
    initialContent = _ref$initialContent === void 0 ? null : _ref$initialContent,
    _ref$optionsExclusion = _ref.optionsExclusionKey,
    optionsExclusionKey = _ref$optionsExclusion === void 0 ? '' : _ref$optionsExclusion,
    title = _ref.title,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? {} : _ref$value,
    parentContentPath = _ref.parentContentPath,
    onChange = _ref.onChange;
  const classNames = useMemo(() => classnames('tqc-control', 't-rb-add-button', "t-ab-".concat(kebabCase(title))), [title]);
  const handleAdd = async function handleAdd(event) {
    let newItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const addPath = convertToAbsolutePath(contentPath, parentContentPath);
    let newItemContent = _objectSpread({
      _created: moment().toISOString()
    }, newItem);
    if (initialContent) {
      newItemContent = _objectSpread(_objectSpread({}, newItemContent), initialContent);
    }
    const uuid = uuidV4().toUpperCase();
    const newDataPath = "".concat(addPath, "/").concat(uuid);
    await onChange({
      path: newDataPath,
      value: newItemContent
    });
  };
  let button;
  if (groupedOptions.length) {
    button = /*#__PURE__*/React.createElement(AddFromOptionsButton, {
      block: true,
      className: classNames,
      enabled: enabled,
      groupedOptions: groupedOptions,
      onAdd: handleAdd,
      optionsExclusionKey: optionsExclusionKey,
      title: title,
      value: value
    });
  } else {
    button = /*#__PURE__*/React.createElement(Button, {
      block: true,
      className: classNames,
      disabled: !enabled,
      onClick: handleAdd
    }, title);
  }
  return button;
};
AddButton.propTypes = {
  enabled: PropTypes.bool.isRequired,
  contentPath: PropTypes.string.isRequired,
  parentContentPath: PropTypes.string.isRequired,
  groupedOptions: PropTypes.arrayOf(PropTypes.shape({})),
  initialContent: PropTypes.shape({}),
  onChange: PropTypes.func.isRequired,
  optionsExclusionKey: PropTypes.string,
  title: PropTypes.string.isRequired,
  value: PropTypes.shape({})
};
export { AddButton as UncomposedAddButton };
export default entityComposition(AddButton, [], {
  enabled: enabledSelector,
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange,
  path: newPathSelector
});